export enum AssistFeatures {
  RescueLeftScheduling = 1,
  FollowUpAppointmentReminder = 2,
  CustomerAppointmentOverview = 3,
  CustomerContactOverview = 4,
  PersonalizeAppointment = 5,
  RescueCancelAppointment = 6,
  RescueNoShowAppointment = 7,
  SiteOverview = 8,
  DigitalCustomerContact = 9,
  HumanCustomerContact = 10,
  AppointmentConfirmationFlow = 11,
  CreateTrackableLinks = 12,
  OutboundVoiceCustomerContactWithIdentifier = 13,
  PhoneNumber = 14,
  ContactsHistory = 15,
}
